import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=0c9786d0&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=0c9786d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9786d0",
  null
  
)

export default component.exports